export default __webpack_public_path__ + "static/21-432d85a1a79cd65940c4d6e64a3d00be.png";